/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


export default {
  /*SET_TODO_SEARCH_QUERY (state, query) {
    state.todoSearchQuery = query
  },
  UPDATE_TODO_FILTER (state, filter) {
    state.todoFilter = filter
  },

  // API
  SET_TASKS (state, tasks) {
    state.tasks = tasks
  },
  SET_TAGS (state, tags) {
    state.taskTags = tags
  },
  ADD_TASK (state, task) {
    state.tasks.unshift(task)
  },
  UPDATE_TASK (state, task) {
    const taskIndex = state.tasks.findIndex((t) => t.id === task.id)
    Object.assign(state.tasks[taskIndex], task)
  },*/
  ADD_SELECTED_CHARACTERISTIC (state, characteristic) {
    state.characteristic = characteristic
  },
  ADD_SKILL_STEP (state, step){
    state.addSkillStep = step
  },
  REMOVE_SELECTED_CHARACTERISTIC (state, characteristic) {
    const chIndex = state.characteristic.findIndex(ch => ch === characteristic)
    state.characteristic.splice(chIndex, 1)
  },
  SEARCH_COMPETENCY(state, value) {
    state.searchCompetency = value
  },
  SET_SELECTED_COMPETENCY (state, competency) {
    state.competency = competency
  },
  SET_INITIAL_LEVEL (state, initialLevel) {
    state.initialLevel = initialLevel
  },
  SET_INITIAL_LEVEL_TEXT (state, initialLevelText) {
    state.initialLevelText = initialLevelText
  },
  SET_USED_PROGRESS_MEASURES(state, measures) {
    state.usedProgressMeasures = measures;
  },
  SET_TRAINING_DURATION (state, trainingDuration) {
    state.trainingDuration = trainingDuration
  },
  ADD_PROGRESS_MEASURE (state, progressMeasure) {
    state.progressMeasures.push(progressMeasure)
  },
  REMOVE_PROGRESS_MEASURE (state, progressMeasure) {
    const pmIndex = state.progressMeasures.findIndex(pm => pm === progressMeasure)
    state.progressMeasures.splice(pmIndex, 1)
  },
  ADD_CUSTOM_PROGRESS_MEASURE (state, progressMeasure) {
    state.customProgressMeasures.push(progressMeasure)
  },
  REMOVE_CUSTOM_PROGRESS_MEASURE (state, progressMeasure) {
    const pmIndex = state.customProgressMeasures.findIndex(pm => pm === progressMeasure)
    state.customProgressMeasures.splice(pmIndex, 1)
  },
  DESTROY_ADD_SKILL_STEP(state) {
    state.addSkillStep = 1
  },
  DESTROY_CHARACTERISTIC(state) {
    state.characteristic = ''
  },
  DESTROY_SEARCH_COMPETENCY(state) {
    state.searchCompetency = false
  },
  DESTROY_COMPETENCY(state) {
    state.competency = ''
  },
  DESTROY_INITIAL_LEVEL(state) {
    state.initialLevel = ''
  },
  DESTROY_INITIAL_LEVEL_TEXT(state) {
    state.initialLevelText = ''
  },
  DESTROY_TRAINING_DURATION(state) {
    state.trainingDuration = ''
  },
  DESTROY_PROGRESS_MEASURES(state) {
    state.progressMeasures = []
  },
  DESTROY_CUSTOM_PROGRESS_MEASURES(state) {
    state.customProgressMeasures = []
  },
  DESTROY_REVIEW_COMPETENCY(state) {
    state.reviewCompetency = ''
  }
}
